import { type FC, type ReactNode } from "react";
import { ErrorBoundary, type FallbackProps } from "react-error-boundary";
import styled from "styled-components";

import { StatusEnum } from "@ds/model/status-model";

import { StatusMessage } from "@ds/components/status-message";
import { logger } from "@ds/utils/logger";

import { Button, ButtonType } from "./forms/buttons";
import { IconType } from "./icons";

const Wrapper = styled.div`
  display: grid;
  place-items: center;
  height: 100%;
`;

const Content = styled.div`
  text-align: center;
`;

const ErrorMessage = styled.div`
  margin: 10px 0 50px;
  font-size: 1.2rem;
  line-height: 1.2rem;
  color: var(--error-text-color);
  max-width: 1000px;
`;

const errorHandler = (error: Error, info: { componentStack: string }) => {
  logger.error("Error: ", error, "\nStack: ", info.componentStack);
};

const ErrorFallback: FC<FallbackProps> = ({ error, resetErrorBoundary }) => (
  <Wrapper>
    <Content>
      <StatusMessage status={StatusEnum.Error} message="Something went wrong..." />
      <ErrorMessage>{error.message}</ErrorMessage>
      <Button
        label="Try again"
        ariaLabel="refresh button"
        buttonType={ButtonType.Outlined}
        icon={IconType.Refresh}
        onClick={resetErrorBoundary}
      />
    </Content>
  </Wrapper>
);

export const DefaultRenderBoundary: FC<{ children: ReactNode }> = ({ children }) => (
  <ErrorBoundary FallbackComponent={ErrorFallback} onError={errorHandler}>
    {children}
  </ErrorBoundary>
);
